export default "__VITE_ASSET___bhc29Nc__"